export { default } from './BaseSwitcher';
